import { createContext, useContext, useState, useEffect } from "react";
import { I_RealestateCard } from "../model/interface/realestate-card.interface";

export interface ContextRealestateCard {
  values: I_RealestateCard;
  setValues?: React.Dispatch<React.SetStateAction<I_RealestateCard>>;
}

const RealestateCardContextInstances =
  createContext<ContextRealestateCard | null>(null);

interface IRealestateCardContextProps {
  values: I_RealestateCard;
  children: any;
}

function RealestateCardContext(props: IRealestateCardContextProps) {
  const [values, setValues] = useState(props.values);

  useEffect(() => {
    setValues(props.values);
  }, [props.values]);

  const contextValue = { values, setValues };

  return (
    <RealestateCardContextInstances.Provider value={contextValue}>
      {props.children}
    </RealestateCardContextInstances.Provider>
  );
}

function useRealestateCardContext() {
  const context = useContext(RealestateCardContextInstances);
  if (!context) {
    return { values: {} as I_RealestateCard, setValues: () => {} };
  }
  return context;
}

export { RealestateCardContext, useRealestateCardContext };
